import React from "react";
var __jsx = React.createElement;
import { useState } from "react";
import PaymentInfo from "@/pages/checkout/components/PaymentInfo/PaymentInfo";
import BottomSheetPopup from "@componentsShared/BottomSheetPopup__OLD/BottomSheetPopup";
import { useTranslation } from "@i18n";
import SAR from "@componentsShared/SAR/SAR";
var SharedRemDataComp = function SharedRemDataComp(_ref) {
  var _order$customer;
  var order = _ref.order,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$hideData = _ref.hideData,
    hideData = _ref$hideData === void 0 ? false : _ref$hideData,
    _ref$isCash = _ref.isCash,
    isCash = _ref$isCash === void 0 ? false : _ref$isCash,
    _ref$isFinance = _ref.isFinance,
    isFinance = _ref$isFinance === void 0 ? false : _ref$isFinance,
    _ref$hideTheName = _ref.hideTheName,
    hideTheName = _ref$hideTheName === void 0 ? false : _ref$hideTheName;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var _useState = useState(false),
    showAllInfo = _useState[0],
    setShowAllInfo = _useState[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center relative z-[100] ".concat(className)
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full"
  }, /*#__PURE__*/React.createElement("div", null, !hideTheName && /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center mb-5"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "text-blue-old text-base font-bold leading-6"
  }, tShort("remaining/greeting", {
    ns: "web_tracking"
  }), " ", isFinance ? order === null || order === void 0 ? void 0 : order.customer_name : order === null || order === void 0 ? void 0 : (_order$customer = order.customer) === null || _order$customer === void 0 ? void 0 : _order$customer.name)), /*#__PURE__*/React.createElement("div", {
    className: "rounded-lg border border-gray-gainsboro bg-white px-3 py-4 flex flex-col gap-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: " flex flex-col gap-4"
  }, /*#__PURE__*/React.createElement("div", null, isFinance ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
    className: "text-gray-causeway text-sm font-semibold leading-6 mb-2"
  }, tShort("remaining/services_value_label", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("strong", {
    className: "text-gray-text text-base font-bold leading-6"
  }, order === null || order === void 0 ? void 0 : order.post_title)) : /*#__PURE__*/React.createElement("strong", {
    className: "text-gray-text text-base font-bold leading-6"
  }, tShort("remaining/payment_details", {
    ns: "web_tracking"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "h-px bg-gray-gainsboro"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between flex-wrap"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    className: "mb-2 text-gray-causeway text-base font-semibold leading-6"
  }, tShort("remaining/remaining_amount", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("strong", {
    className: "text-green text-[28px] font-bold leading-8"
  }, isFinance ? order === null || order === void 0 ? void 0 : order.remaining_amount : order === null || order === void 0 ? void 0 : order.remaining_price_payed, /*#__PURE__*/React.createElement(SAR, null))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    className: "mb-2 text-gray-causeway text-base font-semibold leading-6"
  }, tShort("remaining/paid_amount", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("strong", {
    className: "text-navy-primary text-[28px] font-bold leading-8"
  }, isFinance ? order === null || order === void 0 ? void 0 : order.paid_amount : order === null || order === void 0 ? void 0 : order.payed_amount, /*#__PURE__*/React.createElement(SAR, null))))), /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      return setShowAllInfo(true);
    },
    className: "border-t border-gray-gainsboro bg-blue-pale h-10 flex items-center justify-center text-xs font-semibold leading-4 text-gray-causeway rounded-b-lg cursor-pointer"
  }, tShort("remaining/show_details", {
    ns: "web_tracking"
  }))))), /*#__PURE__*/React.createElement(BottomSheetPopup, {
    noPadding: true,
    className: "w-[563px]",
    show: showAllInfo,
    onClose: function onClose() {
      return setShowAllInfo(false);
    }
  }, /*#__PURE__*/React.createElement("div", {
    onClick: function onClick(e) {
      e.target == e.currentTarget && setShowAllInfo(false);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "static w-full bg-white border border-gray-gainsboro lg:rounded-2xl"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between p-6 border-b border-gray-gainsboro"
  }, /*#__PURE__*/React.createElement("strong", {
    className: "text-gray-text text-xl leading-8"
  }, tShort("remaining/payment_details", {
    ns: "web_tracking"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "overflow-y-auto h-[calc(100%-73px)]"
  }, /*#__PURE__*/React.createElement(PaymentInfo, {
    loading: false,
    checkoutOrder: order,
    hideData: hideData,
    showRemainingData: isCash,
    isFinance: isFinance
  }))))));
};
export default SharedRemDataComp;